<script>
import {
  pointRetraitSelectorEmits,
  pointRetraitSelectorProps,
  usePointRetraitSelector
} from "./mixin";
import Map from "@/components/molecules/map";
import Popin from "@/components/molecules/popin";
import ButtonIcon from "@/components/molecules/button-icon";
import List from "@/components/molecules/list";
import ListItem from "@/components/molecules/list/list-item";
import ShippingServiceContainer from "@/containers/shipping-method/shipping-method-service";

export default {
  name: "PointRetraitSelectorMobile",
  components: {
    Map,
    Popin,
    ButtonIcon,
    List,
    ListItem,
    ShippingServiceContainer
  },
  props: {
    checked: {
      type: Boolean,
      required: false,
      default: false
    },
    ...pointRetraitSelectorProps()
  },
  emits: [...pointRetraitSelectorEmits()],
  data() {
    return {
      wantedPosition: null,
      currentService: null
    };
  },
  methods: {
    localize(service) {
      this.wantedPosition = this.getServicePosition(service);
      this.$refs.popin.show();
    },
    mapReady() {
      if (this.wantedPosition && this.map) {
        this.map.showMarkerByPosition(this.wantedPosition);
      }
    },
    serviceChoosen(service) {
      this.currentService = service;
      this.serviceSelected(service);
    },
    serviceChoosenFromMap(position) {
      const service = this.getServiceFromPosition(position);
      this.$refs.popin.hide();
      if (service) {
        this.serviceChoosen(service);
        const domElem = document.getElementById(`point-${service.id}`);
        if (domElem) {
          domElem.scrollIntoView();
        }
      }
    }
  },
  setup(props, context) {
    const map = ref(null);
    const PointRetraitSelectorItem = defineAsyncComponent(() =>
      import("./point-retrait-selector-item/mobile")
    );
    const {
      positions,
      showMap,
      serviceSelected,
      getServiceFromPosition,
      getServicePosition
    } = usePointRetraitSelector(props, context);
    return {
      positions,
      showMap,
      serviceSelected,
      getServiceFromPosition,
      getServicePosition,
      PointRetraitSelectorItem,
      map
    };
  }
};
</script>

<template>
  <div class="c-point-retrait-selector">
    <Popin
      ref="popin"
      page-back
      aria-label="Selectionner un point retrait"
      @closed="wantedPosition = null"
    >
      <div class="c-point-retrait-selector__map-container">
        <Map
          ref="map"
          :positions="positions"
          class="c-point-retrait-selector__map"
          @positionClicked="serviceChoosenFromMap($event)"
          @ready="mapReady()"
        />
      </div>
    </Popin>
    <div
      v-if="showMap"
      class="u-mb-md u-ml-sm"
    >
      <ButtonIcon
        icon-name="location"
        icon-color="white"
        variant="primary"
        radius="full"
        size="md"
        @click="$refs.popin.show()"
      >
        Voir la carte
      </ButtonIcon>
    </div>
    <List>
      <ListItem
        v-for="service in services"
        :key="`point-${service.id}`"
        class="c-point-retrait-selector__item"
      >
        <ShippingServiceContainer
          :id="`point-${service.id}`"
          :service="service"
          :component="PointRetraitSelectorItem"
          :checked="currentService && (service.id === currentService.id) ? true : false"
          @click="serviceChoosen(service)"
          @localize="localize(service)"
        />
      </ListItem>
    </List>
  </div>
</template>

<style lang="scss" scoped>
.c-point-retrait-selector__map {
  height: calc(100vh - 59px);
  width: 100%;
  overflow: hidden;
  max-height: 100%;
}
.c-point-retrait-selector__map-container {
  height: 100%;
  width: 100%;
  overflow: hidden;
  margin-top: -32px;
}
.c-point-retrait-selector {
  background: color(white);
  .c-point-retrait-selector__item {
    border-bottom: 1px solid color(grey-4);
    display: flex;
    background: color(white);
    &:first-child {
      border-top: 1px solid color(grey-4);
    }
  }
}
</style>
